// Anti-corruption layer: raw device field names -> the view's model.
// See the READINGS wire format in the firmware SerialCommandService.
export default function mapReadings(raw) {
  return {
    pm1: raw.pm_ae_1_0,
    pm25: raw.pm_ae_2_5,
    pm10: raw.pm_ae_10_0,
    pmSp1: raw.pm_sp_1_0,
    pmSp25: raw.pm_sp_2_5,
    pmSp10: raw.pm_sp_10_0,
    co2: raw.co2,
    temp: raw.temp,
    humidity: raw.humidity,
    voc: raw.tvoc,
    hcho: raw.hcho,
    pc03: raw.pc_0_3,
    pc05: raw.pc_0_5,
    pc10: raw.pc_1_0,
    pc25: raw.pc_2_5,
    pc50: raw.pc_5_0,
    pc100: raw.pc_10_0,
    // Multi-gas channels (VPSIAIRPLUS). null/undefined when the sensor is
    // absent, uncalibrated, or warming up — never fabricated.
    // Sensirion VOC Index (SEN66) - unitless 1..500 centred on 100. Kept
    // distinct from `voc` above, which is the PTQS1005's absolute ppm reading.
    vocIndex: raw.voc_index,
    nox: raw.nox,
    coRaw: raw.co_raw,
    coPpm: raw.co_ppm,
    mercRaw: raw.merc_raw,
    mercPpm: raw.merc_ppm,
    ageMs: raw.age_ms,
  };
}
